(function () {
  'use strict';
  var root = document.querySelector('[data-lrb]');
  if (!root || !window.LnaRoomCatalog || !window.LnaRoomLayout) return;

  var C = window.LnaRoomCatalog, L = window.LnaRoomLayout, P = window.LnaRoomPricing;
  var data = JSON.parse(root.querySelector('[data-lrb-data]').textContent);
  var lang = (data.locale || 'fr').slice(0, 2);
  var T = window.LnaRoomI18n[lang] || window.LnaRoomI18n.en;
  var KEY = 'lrb:v1';
  var TABS = ['veilleuse', 'alphabet', 'etagere', 'miroir', 'sticker'];
  var STICKERS_PER_PACK = 22;
  var index = C.indexVariants(data.products);
  var money = new Intl.NumberFormat(data.locale, { style: 'currency', currency: data.currency });
  var portrait = window.matchMedia('(max-width: 749px)');
  var $ = function (sel) { return root.querySelector(sel); };
  var els = {
    start: $('[data-lrb-start]'), stage: $('[data-lrb-stage]'), room: $('[data-lrb-room]'),
    objects: $('[data-lrb-objects]'), stickers: $('[data-lrb-stickers]'), tabs: $('[data-lrb-tabs]'),
    grid: $('[data-lrb-grid]'), count: $('[data-lrb-count]'), total: $('[data-lrb-total]'),
    add: $('[data-lrb-add]'), was: $('[data-lrb-was]'), rule: $('[data-lrb-rule]'), next: $('[data-lrb-next]'), gender: $('[data-lrb-gender]'), toolbar: $('[data-lrb-toolbar]'),
    toast: $('[data-lrb-toast]'), hint: $('[data-lrb-hint]'),
    picker: $('[data-lrb-picker]'), pickerTitle: $('[data-lrb-picker-title]'), pickerOptions: $('[data-lrb-picker-options]')
  };
  var state = { gender: null, items: [], night: true, tab: 'veilleuse', selected: null };
  window.LnaRoomBuilder = { state: state };

  root.querySelectorAll('[data-t]').forEach(function (el) { el.textContent = T[el.getAttribute('data-t')]; });
  root.querySelectorAll('[data-t-label]').forEach(function (el) { el.setAttribute('aria-label', T[el.getAttribute('data-t-label')]); });

  function load() {
    try {
      var saved = JSON.parse(localStorage.getItem(KEY) || 'null');
      if (!saved || (saved.gender !== 'fille' && saved.gender !== 'garcon')) return;
      state.gender = saved.gender;
      if (typeof saved.night === 'boolean') state.night = saved.night;
      state.items = C.sanitize(saved.items, index).filter(function (it) { return C.isVisible(index[it.variantId], state.gender); });
    } catch (e) { /* stockage indisponible : on repart de zéro */ }
  }
  function save() {
    try { localStorage.setItem(KEY, JSON.stringify({ gender: state.gender, night: state.night, items: state.items })); } catch (e) {}
  }

  function roomConf() { return data.room[state.gender][portrait.matches ? 'portrait' : 'landscape']; }
  function uid() { return Date.now().toString(36) + Math.random().toString(36).slice(2, 7); }
  function el(tag, cls, text) { var n = document.createElement(tag); if (cls) n.className = cls; if (text != null) n.textContent = text; return n; }

  function addItem(variantId) {
    var e = index[variantId];
    if (!e || !e.variant.available) return;
    // stickers : plusieurs couleurs d'un même pack possibles ; retoucher une couleur posée la retire
    if (e.product.category === 'sticker' && state.items.some(function (it) { return it.variantId === e.variant.id; })) {
      state.items = state.items.filter(function (it) { return it.variantId !== e.variant.id; });
      update();
      return;
    }
    // un ajout réorganise toute la chambre : rien ne peut se poser sur un objet déplacé à la main
    state.items.forEach(function (it) { delete it.manual; });
    state.items.push({ uid: uid(), productId: e.product.id, variantId: e.variant.id, category: e.product.category });
    update();
  }


  function openPicker(p) {
    els.pickerTitle.textContent = C.shortName(p.title);
    els.pickerOptions.innerHTML = '';
    p.variants.forEach(function (v) {
      var placed = p.category === 'sticker' && state.items.some(function (it) { return it.variantId === v.id; });
      var b = el('button', 'lrb-pick' + (placed ? ' is-on' : '')); b.type = 'button';
      b.setAttribute('data-variant', v.id); b.disabled = !v.available;
      var img = el('img', 'lrb-pick__img'); img.src = v.day; img.alt = ''; img.loading = 'lazy';
      b.appendChild(img);
      b.appendChild(el('span', 'lrb-pick__name', v.available ? v.title : v.title + ' · ' + T.soldOut));
      b.addEventListener('click', function () { closePicker(); addItem(v.id); });
      els.pickerOptions.appendChild(b);
    });
    els.picker.hidden = false;
    var first = els.pickerOptions.querySelector('button:not([disabled])');
    if (first) first.focus();
  }

  function closePicker() { els.picker.hidden = true; }
  function removeItem(u) {
    state.items = state.items.filter(function (it) { return it.uid !== u; });
    if (state.selected === u) state.selected = null;
    update();
  }
  function recolor(u, variantId) {
    state.items.forEach(function (it) { if (it.uid === u) it.variantId = variantId; });
    update();
  }

  function renderTabs() {
    els.tabs.innerHTML = '';
    TABS.forEach(function (t) {
      var b = el('button', 'lrb-tab' + (t === state.tab ? ' is-on' : ''), T.tabs[t]);
      b.type = 'button'; b.setAttribute('role', 'tab'); b.setAttribute('aria-selected', t === state.tab);
      b.addEventListener('click', function () { state.tab = t; renderTabs(); renderGrid(); });
      els.tabs.appendChild(b);
    });
  }

  function card(p) {
    var inRoom = state.items.filter(function (it) { return it.productId === p.id; });
    var available = p.variants.filter(function (v) { return v.available; });
    var c = el('div', 'lrb-card' + (inRoom.length ? ' is-in' : '') + (available.length ? '' : ' is-out'));
    c.setAttribute('data-product', p.id);
    if (available.length > 1) c.setAttribute('data-multi', '');
    var b = el('button', 'lrb-card__main'); b.type = 'button';
    var img = el('img', 'lrb-card__img'); img.src = (available[0] || p.variants[0]).thumb; img.alt = ''; img.loading = 'lazy';
    var badge = el('span', 'lrb-card__badge', inRoom.length > 1 ? String(inRoom.length) : (inRoom.length ? '✓' : '+'));
    b.appendChild(img); b.appendChild(badge);
    if (p.featured && p.category !== 'alphabet') b.appendChild(el('span', 'lrb-card__fav', '♥'));
    b.appendChild(el('span', 'lrb-card__title', C.shortName(p.title)));
    b.appendChild(el('span', 'lrb-card__price', available.length ? money.format(available[0].price / 100) : T.soldOut));
    b.disabled = !available.length;
    b.addEventListener('click', function () {
      if (available.length === 1) addItem(available[0].id);
      else openPicker(p);
    });
    c.appendChild(b);
    return c;
  }

  // Une seule grille : coups de cœur en tête (petit cœur sur la vignette) ; l'Alphabet de A à Z.
  function renderGrid() {
    els.grid.innerHTML = '';
    var list = C.visibleProducts(data.products, state.gender).filter(function (p) { return p.category === state.tab; });
    if (state.tab === 'alphabet') {
      list.sort(function (a, b) { return C.letterOf(a) < C.letterOf(b) ? -1 : C.letterOf(a) > C.letterOf(b) ? 1 : 0; });
    } else {
      list = list.filter(function (p) { return p.featured; }).concat(list.filter(function (p) { return !p.featured; }));
    }
    var g = el('div', 'lrb-grid__cards');
    list.forEach(function (p) { g.appendChild(card(p)); });
    els.grid.appendChild(g);
  }

  function renderRoom() {
    var conf = roomConf();
    els.room.style.aspectRatio = (1 / conf.aspect).toFixed(4);
    root.querySelector('[data-lrb-bg="day"]').src = conf.day;
    root.querySelector('[data-lrb-bg="night"]').src = conf.night;
    root.classList.toggle('is-night', state.night);
    root.querySelectorAll('[data-lrb-mode]').forEach(function (b) {
      b.classList.toggle('is-on', (b.getAttribute('data-lrb-mode') === 'night') === state.night);
    });
    els.gender.textContent = (state.gender === 'fille' ? T.girl : T.boy) + ' · ' + T.change;
    els.hint.hidden = state.items.length > 0;

    var placed = state.items.map(function (it) {
      var e = index[it.variantId];
      // k : largeur de l'image / plus grand côté de l'objet sans son cordon → toutes les veilleuses à la même échelle
      return Object.assign({}, it, { widthCm: e.product.widthCm * (e.variant.k || 1), ar: e.variant.ar });
    });
    var rects = L.layout(placed, conf);
    var keep = {};
    placed.forEach(function (it) {
      var r = rects[it.uid]; if (!r) return;
      keep[it.uid] = true;
      var e = index[it.variantId];
      var node = els.objects.querySelector('[data-uid="' + it.uid + '"]');
      if (!node) {
        node = el('button', 'lrb-obj'); node.type = 'button'; node.setAttribute('data-uid', it.uid);
        node.appendChild(el('img', 'lrb-day')); node.appendChild(el('img', 'lrb-night'));
        bindDrag(node);
        els.objects.appendChild(node);
      }
      node.querySelector('.lrb-day').src = e.variant.day;
      node.querySelector('.lrb-night').src = e.variant.night || e.variant.day;
      node.classList.toggle('is-light', !!e.variant.night);
      node.classList.toggle('is-selected', state.selected === it.uid);
      node.setAttribute('aria-label', e.product.title);
      node.style.left = r.x + '%'; node.style.top = r.y + '%';
      node.style.width = r.w + '%'; node.style.height = r.h + '%';
    });
    els.objects.querySelectorAll('[data-uid]').forEach(function (n) { if (!keep[n.getAttribute('data-uid')]) n.remove(); });

    els.stickers.innerHTML = '';
    var avoid = Object.keys(rects).map(function (k) { return rects[k]; });
    var lamps = {};
    var GROUP = { veilleuse: 1, etagere: 1, miroir: 1 };  // le groupe que stickers et petits nuages entourent
    placed.forEach(function (it) { if (GROUP[it.category] && rects[it.uid]) lamps[it.uid] = rects[it.uid]; });
    var region = L.stickerRegion(lamps, conf.zones.wall);
    // un semis (ou des petits nuages) par pack de stickers, les couleurs choisies mélangées
    var packs = {};
    state.items.forEach(function (it) {
      if (it.category === 'sticker') (packs[it.productId] = packs[it.productId] || []).push(index[it.variantId].variant);
    });
    Object.keys(packs).forEach(function (pid) {
      var colors = packs[pid], product = index[colors[0].id].product, n = colors.length;
      var w0 = product.widthCm * conf.cmToPct;
      if (product.layout === 'trio') {
        L.trio(lamps, conf.zones.wall, { w: w0, h: w0 / (colors[0].ar || 1) / conf.aspect }, 3 * n).forEach(function (r, i) {
          var s = el('img', 'lrb-sticker lrb-sticker--relief'); s.src = colors[i % n].day; s.alt = '';
          s.style.cssText = 'left:' + r.x + '%;top:' + r.y + '%;width:' + r.w + '%';
          els.stickers.appendChild(s);
        });
        return;
      }
      L.scatter(L.seedOf(pid), Math.min(STICKERS_PER_PACK * n, 44), region, avoid).forEach(function (p, i) {
        var s = el('img', 'lrb-sticker'); s.src = colors[i % n].day; s.alt = '';
        var w = w0 * p.s;
        s.style.cssText = 'left:' + (p.x - w / 2) + '%;top:' + p.y + '%;width:' + w + '%;transform:translateY(-50%) rotate(' + p.r + 'deg)';
        els.stickers.appendChild(s);
      });
    });
    renderToolbar();
  }

  function renderToolbar() {
    var it = state.items.filter(function (x) { return x.uid === state.selected; })[0];
    els.toolbar.hidden = !it;
    if (!it) return;
    els.toolbar.innerHTML = '';
    var e = index[it.variantId];
    var product = C.visibleProducts([e.product], state.gender)[0];
    (product ? product.variants : []).forEach(function (v) {
      if (product.variants.length < 2) return;
      var s = el('button', 'lrb-swatch' + (v.id === it.variantId ? ' is-on' : ''), v.title); s.type = 'button';
      s.disabled = !v.available;
      s.addEventListener('click', function () { recolor(it.uid, v.id); });
      els.toolbar.appendChild(s);
    });
    var rm = el('button', 'lrb-toolbar__remove', T.remove); rm.type = 'button';
    rm.addEventListener('click', function () { removeItem(it.uid); });
    els.toolbar.appendChild(rm);
  }

  // Prix « Créer votre chambre » (même calcul que la remise du panier), dans la devise du client.
  var rate = (window.Shopify && Shopify.currency && Number(Shopify.currency.rate)) || 1;
  function renderBar() {
    var n = state.items.length;
    els.count.textContent = T.items(n);
    var lines = state.items.map(function (it) {
      var e = index[it.variantId];
      return { id: it.uid, category: e.product.category, price: e.variant.price, quantity: 1,
        supplement: e.product.supplement || 0, excluded: !!e.product.excluded };
    });
    var list = C.total(state.items, index);
    var r = P ? P.compute(lines, rate) : { count: 0, lightsDiscount: 0, packDiscount: 0, freePackId: null };
    var final = list - r.lightsDiscount - r.packDiscount;
    els.total.textContent = money.format(final / 100);
    els.was.hidden = final >= list;
    els.was.textContent = money.format(list / 100);
    // l'économie réalisée, toujours juste quel que soit le contenu de la chambre (la règle de calcul détaillée prêtait à confusion)
    els.rule.hidden = final >= list;
    els.rule.textContent = T.save(money.format((list - final) / 100));
    // « La 4e veilleuse à partir de 30 € » : le minimum réel, juste quelle que soit la veilleuse ajoutée
    var step = P ? P.nextStep(lines, rate) : null;
    els.next.hidden = !step;
    if (step) els.next.textContent = T.next(step.count, money.format(step.price / 100));
    els.add.disabled = !n;
  }

  function update() { save(); renderRoom(); renderGrid(); renderBar(); }

  // Glisser au doigt ou à la souris ; un toucher sans mouvement sélectionne.
  // L'objet suit le doigt à l'endroit où on l'a attrapé et garde sa taille.
  function bindDrag(node) {
    var start = null;
    node.addEventListener('pointerdown', function (ev) {
      if (!ev.isPrimary || ev.button > 0) return;
      var r = node.getBoundingClientRect();
      start = { x: ev.clientX, y: ev.clientY, moved: false, dx: ev.clientX - (r.left + r.width / 2),
        dy: ev.clientY - (r.top + r.height / 2), w: r.width };
      try { node.setPointerCapture(ev.pointerId); } catch (e) { /* capture indisponible : le glisser marche quand même */ }
    });
    node.addEventListener('pointermove', function (ev) {
      if (!start || !ev.isPrimary) return;
      if (!start.moved && Math.hypot(ev.clientX - start.x, ev.clientY - start.y) < 6) return;
      start.moved = true;
      node.classList.add('is-dragging');
      var box = els.room.getBoundingClientRect();
      var manual = {
        x: Math.max(0, Math.min(100, (ev.clientX - start.dx - box.left) / box.width * 100)),
        y: Math.max(0, Math.min(100, (ev.clientY - start.dy - box.top) / box.height * 100)),
        w: start.w / box.width * 100
      };
      var u = node.getAttribute('data-uid');
      state.items.forEach(function (it) { if (it.uid === u) it.manual = manual; });
      renderRoom();
    });
    function end(ev) {
      if (!start) return;
      var u = node.getAttribute('data-uid');
      if (!start.moved && ev.type === 'pointerup') state.selected = state.selected === u ? null : u;
      start = null;
      node.classList.remove('is-dragging');
      save(); renderRoom();
    }
    node.addEventListener('pointerup', end);
    node.addEventListener('pointercancel', end);
  }

  // Sur mobile la chambre reste collée juste sous l'en-tête du thème (bandeau promo + menu, collants eux aussi).
  function syncStickyTop() {
    var bottom = 0;
    document.querySelectorAll('.shopify-section-group-header-group').forEach(function (s) {
      var pos = getComputedStyle(s).position;
      if (pos === 'sticky' || pos === 'fixed') bottom = Math.max(bottom, s.getBoundingClientRect().bottom);
    });
    root.style.setProperty('--lrb-top', Math.max(0, Math.round(bottom)) + 'px');
  }
  var stickyQueued = false;
  function queueStickyTop() {
    if (stickyQueued) return;
    stickyQueued = true;
    requestAnimationFrame(function () { stickyQueued = false; syncStickyTop(); });
  }

  function toast(msg) {
    els.toast.textContent = msg; els.toast.hidden = false;
    clearTimeout(toast.t); toast.t = setTimeout(function () { els.toast.hidden = true; }, 4000);
  }

  function postLines(lines) {
    return fetch(data.cartAddUrl, {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: lines })
    }).then(function (r) {
      // Seul le message de Shopify (ex. « produit épuisé ») est montré tel quel ; tout le reste → message clair.
      return r.json().catch(function () { return null; }).then(function (j) {
        if (r.ok && j) return j;
        var err = new Error((j && j.description) || T.cartError);
        err.forCustomer = true;
        throw err;
      });
    });
  }

  // Première visite : un script de suivi crée parfois son propre panier (vide) en même temps que l'ajout et le
  // remplace. On vérifie le panier un instant après et on rajoute la chambre une fois si elle a disparu.
  function ensureInCart(lines, retried) {
    var wanted = lines.reduce(function (n, l) { return n + l.quantity; }, 0);
    return new Promise(function (ok) { setTimeout(ok, 1200); })
      .then(function () { return fetch('/cart.js', { cache: 'no-store' }).then(function (r) { return r.json(); }); })
      .then(function (cart) {
        if (cart.item_count >= wanted || retried) return;
        return postLines(lines).then(function () { return ensureInCart(lines, true); });
      })
      .catch(function () { /* la vérification ne doit jamais bloquer l'ouverture du panier */ });
  }

  // Le thème (FoxTheme) recharge et ouvre son tiroir panier sur l'événement cart:refresh.
  function addToCart() {
    var lines = C.cartLines(state.items);
    if (!lines.length) return;
    els.add.disabled = true;
    postLines(lines).then(function () {
      return ensureInCart(lines);
    }).then(function () {
      if (document.querySelector('cart-drawer')) {
        document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { open: true } }));
      } else {
        window.location.href = data.cartUrl;
      }
    }).catch(function (err) {
      toast(err && err.forCustomer ? err.message : T.cartError);
    }).then(function () { els.add.disabled = !state.items.length; });
  }

  function chooseGender(g) {
    if (state.gender && g !== state.gender) {
      var hidden = C.hiddenItems(state.items, g, index);
      if (hidden.length && !window.confirm(T.switchConfirm(hidden.length))) return;
      state.items = state.items.filter(function (it) { return hidden.indexOf(it) < 0; });
    }
    state.gender = g; state.selected = null;
    els.start.hidden = true; els.stage.hidden = false;
    renderTabs(); update();
  }

  root.querySelectorAll('[data-gender]').forEach(function (b) {
    b.addEventListener('click', function () { chooseGender(b.getAttribute('data-gender')); });
  });
  els.gender.addEventListener('click', function () { chooseGender(state.gender === 'fille' ? 'garcon' : 'fille'); });
  root.querySelectorAll('[data-lrb-mode]').forEach(function (b) {
    b.addEventListener('click', function () { state.night = b.getAttribute('data-lrb-mode') === 'night'; save(); renderRoom(); });
  });
  $('[data-lrb-rearrange]').addEventListener('click', function () {
    state.items.forEach(function (it) { delete it.manual; }); update();
  });
  $('[data-lrb-clear]').addEventListener('click', function () {
    if (state.items.length && window.confirm(T.clearConfirm)) { state.items = []; state.selected = null; update(); }
  });
  els.room.addEventListener('click', function (ev) {
    if (ev.target === els.room || ev.target.classList.contains('lrb-room__bg')) { state.selected = null; renderRoom(); }
  });
  els.add.addEventListener('click', addToCart);
  els.picker.addEventListener('click', function (ev) {
    if (ev.target === els.picker || ev.target.closest('[data-lrb-picker-close]')) closePicker();
  });
  document.addEventListener('keydown', function (ev) { if (ev.key === 'Escape' && !els.picker.hidden) closePicker(); });
  portrait.addEventListener('change', renderRoom);
  window.addEventListener('scroll', queueStickyTop, { passive: true });
  window.addEventListener('resize', queueStickyTop);
  syncStickyTop();

  // Arrivée depuis une fiche produit (?ajouter=<variante>) : la veilleuse est déjà posée, le genre suit le produit.
  function fromProductPage() {
    var params = new URLSearchParams(window.location.search);
    var e = index[params.get('ajouter')];
    if (params.has('ajouter')) {
      params.delete('ajouter');
      var q = params.toString();
      history.replaceState(null, '', window.location.pathname + (q ? '?' + q : '') + window.location.hash);
    }
    if (!e || !e.variant.available) return null;
    var g = e.variant.gender !== 'mixte' ? e.variant.gender : e.product.gender;
    if ((g === 'fille' || g === 'garcon') && g !== state.gender) {
      state.gender = g;
      state.items = state.items.filter(function (it) { return C.isVisible(index[it.variantId], g); });
    }
    return e.variant.id;
  }

  load();
  var incoming = fromProductPage();
  if (state.gender) {
    els.stage.hidden = false; renderTabs(); update();
    if (incoming && !state.items.some(function (it) { return it.variantId === incoming; })) addItem(incoming);
  } else {
    els.start.hidden = false;
    if (incoming) {  // produit mixte : on demande Fille / Garçon, puis on le pose
      root.querySelectorAll('[data-gender]').forEach(function (b) {
        b.addEventListener('click', function () { if (incoming) { addItem(incoming); incoming = null; } });
      });
    }
  }
})();
